<template>
    <div>
        <Dialog v-model:visible="isDialog" :style="{'width': '1200px','max-height': '1000px'}" :header="codehelp.helpNm" :modal="true" class="fluid">
            <Toolbar class="mb-2">
                <template #start>
                    <div class="grid">
                        <template v-for="cond in conds" v-bind:key="cond.id">
                            <label class="col-fixed mt-2" style="width:5em;">{{cond.condNm}}</label>
                            <div class="col">
                                <InputText :inputId="cond.condId" type="text" v-model.trim="cond.value" :readonly="cond.condId === 'CORP_ID'"
                                        @keydown.enter="btnAct('SEARCH')" style="width:8em;"/>
                            </div>
                        </template>
                        <div class="field-radiobutton mt-3 mr-2">
                            <RadioButton id="compareType1" name="compareType" value="LIKE" v-model="searchParams.compareType" />
                            <label for="searchCond1" class="mr-2">검색어%</label>
                            <RadioButton id="compareType2" name="compareType" value="LIKE2" v-model="searchParams.compareType" />
                            <label for="searchCond2" class="mr-2">%검색어%</label>
                            <RadioButton id="compareType3" name="compareType" value="MATCH" v-model="searchParams.compareType" />
                            <label for="searchCond3" class="mr-2">=검색어</label>
                        </div>
                    </div>
                </template>
                <template #end>
                    <div class="grid">
                        <Button label="조회" icon="pi pi-search" class="mr-2" @click="btnAct('SEARCH')" />
                        <Button label="적용" icon="pi pi-check" class="p-button-secondary mr-2" @click="btnAct('SELECT')" />
                    </div>
                </template>
            </Toolbar>

            <DataTable :value="dataList" :scrollable="true" scrollHeight="600px" :loading="loading" class="p-datatable-sm"  
                selectionMode="single" :metaKeySelection="false" v-model:selection="selectedItem" 
                @row-dblclick="onRowDblClick($event)"
                 responsiveLayout="scroll">
                <Column header="No" style="min-width:3em; max-width:3em">
                    <template #body="{index}">
                        {{ index + 1 }}
                    </template>    
                </Column>
                <template v-for="col of columns" :key="col.colSerl">  
                    <Column :field="col.colId" :header="col.colNm"  :style="colStyle(col.width)" v-if="!col.hiddenYn"></Column>
                </template>				
                <!-- 
                아래 코드는 에러가 발생함 - v-for문과 v-if 문을 한 라이인에서 동시에 사용할 수 없음
                <Column v-for="col of columns" :field="col.colId" :header="col.colNm" :key="col.colSerl" :style="colStyle(col.width)" v-if="!col.hiddenYn"></Column>
                -->
            </DataTable>
        </Dialog>
    </div>
</template>

<script>
import {  onMounted, ref, watch } from '@vue/runtime-core'
import { useToast } from 'primevue/usetoast';
import CodeHelpService from '@/service/cm/CodeHelpService';
import CodeHelpCondService from '@/service/cm/CodeHelpCondService';
import CodeHelpColService from '@/service/cm/CodeHelpColService';

export default {
    // props : 부모로 부터 받아로 정보
    props:{
        selection:{
            type:Object,
            default: function() {
                return {}
            },
        },
        search:{
            type:Object,
            default: function() {
                return {}
            },
        },
        visible:{
            type:Boolean,
            default:false
        },
        multiSelect:{
            type:Boolean,
            default:false
        }
    },
    // 부모로 부터 받아로 이벤트 받아온다
    emits: [ 'update:visible', 'update:selection','onComplete'],
    setup(props,{emit}){
        onMounted(()=>{
            searchParams.value.compareType = "LIKE2";   // default

            searchParams2.value.compSeq = searchParams.value.compSeq;
            searchParams2.value.helpId = searchParams.value.helpId;

            //alert('props = ' + JSON.stringify(props));
            //alert('searchParams = ' + JSON.stringify(searchParams.value));
            isMulti.value = props.multiSelect?'multiple':'single';

            // 코드도움 정보를 가져와서 표시한다
            codeHelpService.getOne(searchParams.value.helpId).then(data=> {
                //alert('#1 data = ' + JSON.stringify(data));
                codehelp.value = data;
                codehelp.value.helpNm = "코드도움: " + codehelp.value.helpNm;
            });

            // 검색조건 목록을 가져와서 표시한다
            codeHelpCondService.getCondList(searchParams2.value).then(data=> {
                conds.value = data;
            });

            // 컬럼 목록을 가져와서 표시한다
            codeHelpColService.getColList(searchParams2.value).then(data=> {
                columns.value = data;
            });
        })
        //const searchParams = ref([]);   // 검색조건 동적 항목들
        const searchParams = ref(props.search); // 코드도움 검색조건
        const searchParams2 = ref({}); // 검색조건, 컬럼 검색조건
        const codehelp = ref({});       // 코드도움
        const conds = ref([]);          // 검색조건 항목들
        const columns = ref([]);        // datatable 목록에 표시할 동적 컬럼들
        const dataList = ref([]);       // datatable 목록 데이터
        const selectedItem = ref(props.selection);  // datatable에서 선택한 한 행
        //onst selectedList = ref([]);               // datatable에서 선택한 여러 행들
        const loading = ref(false);
        const toast = useToast();

        const isDialog = ref(props.visible);  // 코드도움 다이얼로그 표시 여부
        const isMulti = ref("single");  // datatable에서 single or multiple 선택 구분

        const codeHelpService = new CodeHelpService();
        const codeHelpCondService = new CodeHelpCondService();
        const codeHelpColService = new CodeHelpColService();

        const searchList = () => {
            //alert('검색 전 #1 searchParams = ' + JSON.stringify(searchParams.value));
            conds.value.forEach(row => {
                if(row.value === undefined) row.value = "";
                searchParams.value[row.condId] = row.value;
            });
            searchParams.value.conds = [];

            loading.value = true;
            codeHelpService.getDataList(searchParams.value).then(data=> {
                if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000});
                dataList.value = data;
            }).finally(() => {
                loading.value = false;
            });
        }
    
        const btnAct = (_act) => {
            switch(_act)
            {
                case "SEARCH":
                    searchList();
                    break;
                case "SELECT":
                    isDialog.value = false;
                    emit('onComplete');
                    break;
            }
        }

        const onRowDblClick = (event) => {
            // 선택된 행(row)을 넘기면서 현재 다이얼로그를 닫는다
            emit('update:selection',event.data);
            btnAct('SELECT');
        }

        const colStyle = (width) => {
            //return "min-width:" + width + "px; " + "max-width:" + (width*1.4) + "px;";
            return "min-width:" + width + "px;";
        }

        watch( 
			() => props.visible, 
			(meta) => {
                isDialog.value = meta;

                if(meta)
                {
                    // 창이 열릴때마다 실행 
                    selectedItem.value = {};
                    dataList.value = [];
                }
            }
        );

        watch(
            () => isDialog.value,
            (meta) =>{    
                //alert('#watch isDialo: searchParams = ' + JSON.stringify(searchParams.value));
                // CodeHelpDialog를 호출하는 부모 페이지에서 검색조건이 넘어온 경우
                if(searchParams.value.conds != null , isDialog.value == true) {
                    const isSearch = ref(false);
                    conds.value.forEach((row, index) => {
                        const param = searchParams.value.conds[index];
                        if(param != null && param != "") {
                            // CodeHelpDialog를 호출하는 부모 페이지에서 넘긴 검색조건으로 현재 CodeHelpDialog의 검색조건에 값을 넣어 표시한다 
                            row.value = searchParams.value.conds[index];
                            isSearch.value = true;
                        }
                    });

                    searchList();
                }
                
                emit('update:visible',meta);
            } 
        )

        watch(
            () => selectedItem.value,
            (meta) =>{
                emit('update:selection',meta);
                //if(meta != null) btnAct("SELECT");
            } 
        )
    
        return{
            searchParams, searchParams2, codehelp, conds, columns, dataList, 
            isDialog, selectedItem, btnAct, isMulti, colStyle, onRowDblClick,
            loading,
            }
    }
}
</script>